import { Reveal, Overline } from "@/components/motion";

const IMG = "https://images.unsplash.com/photo-1609050471053-8636409f9f5b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxlc3ByZXNzbyUyMG1hY2hpbmUlMjBtb2Rlcm4lMjBvZmZpY2UlMjBzcGVjaWFsdHklMjBjb2ZmZWV8ZW58MHx8fHwxNzkyMjIxMDAyfDA&ixlib=rb-4.1.0&q=85";

export const CaseStudy = () => (
  <section data-testid="case-study-section" className="py-24 sm:py-32 bg-[#F7F5F0]">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <Reveal>
          <div className="relative rounded-3xl overflow-hidden border border-[#E2DDD3] shadow-2xl shadow-[#1B5E46]/10">
            <img src={IMG} alt="Espresso being poured" className="w-full h-[420px] object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0B1D16]/60 to-transparent" />
            <span className="absolute top-5 left-5 text-xs font-mono-brand font-semibold uppercase tracking-[0.2em] bg-[#F7F5F0]/90 text-[#0B1E17] rounded-full px-4 py-2">
              Machine #01 — reserved
            </span>
          </div>
        </Reveal>
        <div>
          <Reveal><Overline>First machine spotlight</Overline></Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-4 font-display font-bold tracking-tight text-[#0B1E17] text-2xl sm:text-3xl lg:text-4xl leading-tight">
              This space belongs to our first host.
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-5 text-base sm:text-lg text-[#52665E] leading-relaxed max-w-lg">
              Machine #01 goes live soon — and its story will live here: the workplace, the charity they chose, the cups poured and the pounds raised. Real numbers, updated every Monday.
            </p>
          </Reveal>
          <Reveal delay={0.24}>
            <div className="mt-8 border-l-2 border-[#D97706] pl-5">
              <p className="text-sm text-[#52665E] italic">
                "We want our first case study to be earned, not invented. Your venue could be the story we tell."
              </p>
              <p className="mt-2 text-xs font-mono-brand uppercase tracking-[0.18em] text-[#1B5E46]">The Give &amp; Grind team</p>
            </div>
          </Reveal>
          <Reveal delay={0.3}>
            <a href="/#enquire" data-testid="case-study-cta"
              className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#0F2E23] text-[#F7F5F0] font-bold px-6 py-3 text-sm hover:bg-[#1B5E46] transition-colors duration-300">
              Become machine #01 <span>→</span>
            </a>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
